import { connect } from "react-redux";
// API
import api from "api";
// Action
import { openErrorDialog } from "redux/modules/errorDialog";
import {
  initReportDetail,
  setReportDetail,
  setNewComment,
  updateNewComment,
  setErrors
} from "redux/modules/reportDetail";

// Component
import ReportDetail from "components/ReportDetail";
// Utils
import history from "utils/history";
import { showSnackbar } from "redux/modules/snackbar";
import { openMessageDialog } from "redux/modules/messageDialog";

const mapStateToProps = state => {
  return { ...state };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  historyPush: path => history.push(path, ownProps),
  initReportDetail: () => {
    dispatch(initReportDetail());
  },
  fetchReportDetail: () => {
    const { id } = ownProps.match.params;
    const params = new URLSearchParams(window.location.search);
    const attrItem = params.get('attr_item');
    if (attrItem) {
      api
        .get(`report_detail/${id}`, { attr_item_id: attrItem })
        .then(res => {
          if (res.errors.length > 0) {
            return dispatch(setErrors(res.errors));
          }
          res.summaryResult.comment = res.summaryResult.comment !== null ? res.summaryResult.comment : "（例）地域別の「サッポロ」の満足度が特に大きくなっている。逆に、部門別の「営業」や、地域別の「東京」の満足度が低くなっている。\n勤続の浅い方や外部の方など当社との関わりがまだ強くない従業員の満足度が比較的低くなっている。";
          res.ranking.comment = res.ranking.comment !== null ? res.ranking.comment : "（例）当社においては、尺度の大きさで11位以下の３項目は５０点を下回っており、従業員から否定的な評価となっている。特に「④給与」、「③評価・処遇」の尺度は値が低く、要注意である。\nまた、右の図で相関係数が０．５以上でやや関係性が強い上位の項目は、特に従業員の満足度に影響を及ぼしている可能性がある。";
          res.distribution.comment = res.distribution.comment !== null ? res.distribution.comment : "「満足度との関係性の強さ」ランキングにおいて上位の尺度が満足度向上のキー ポイントとなるが、その中でも値が小さい尺度の方が改善の余地が大きい項目と いえる。よって、当社においてより効率的に従業員満足度を向上させるためには、 上の図で右下に位置する「　　　」、「　　　」、「　　　」といった項目に取 り組むことが有効であると考えられる。それらの尺度を構成する詳細の項目の結 果の中でもより評価の低い（否定的な意見の多い）項目に着目し具体策を考える。";
          res.engagement.comment = res.engagement.comment !== null ? res.engagement.comment : "「エンゲージメントとの関係性の強さ」ランキングにおいて上位の尺度がエンゲージメント向上のキー ポイントとなるが、その中でも値が小さい尺度の方が改善の余地が大きい項目と いえる。よって、当社においてより効率的にエンゲージメントを向上させるためには、 上の図で右下に位置する「　　　」、「　　　」、「　　　」といった項目に取り組むことが有効であると考えられる。それらの尺度を構成する詳細の項目の結果の中でもより評価の低い（否定的な意見の多い）項目に着目し具体策を考える。";
          return dispatch(setReportDetail(res));
        })
        .catch(error => dispatch(openErrorDialog(error)));
    } else {
      api
        .get(`report_detail/${id}`)
        .then(res => {
          if (res.errors.length > 0) {
            return dispatch(setErrors(res.errors));
          }
          res.summaryResult.comment = res.summaryResult.comment !== null ? res.summaryResult.comment : "（例）地域別の「サッポロ」の満足度が特に大きくなっている。逆に、部門別の「営業」や、地域別の「東京」の満足度が低くなっている。\n勤続の浅い方や外部の方など当社との関わりがまだ強くない従業員の満足度が比較的低くなっている。";
          res.ranking.comment = res.ranking.comment !== null ? res.ranking.comment : "（例）当社においては、尺度の大きさで11位以下の３項目は５０点を下回っており、従業員から否定的な評価となっている。特に「④給与」、「③評価・処遇」の尺度は値が低く、要注意である。\nまた、右の図で相関係数が０．５以上でやや関係性が強い上位の項目は、特に従業員の満足度に影響を及ぼしている可能性がある。";
          res.distribution.comment = res.distribution.comment !== null ? res.distribution.comment : "「満足度との関係性の強さ」ランキングにおいて上位の尺度が満足度向上のキー ポイントとなるが、その中でも値が小さい尺度の方が改善の余地が大きい項目と いえる。よって、当社においてより効率的に従業員満足度を向上させるためには、 上の図で右下に位置する「　　　」、「　　　」、「　　　」といった項目に取 り組むことが有効であると考えられる。それらの尺度を構成する詳細の項目の結 果の中でもより評価の低い（否定的な意見の多い）項目に着目し具体策を考える。";
          res.engagement.comment = res.engagement.comment !== null ? res.engagement.comment : "「エンゲージメントとの関係性の強さ」ランキングにおいて上位の尺度がエンゲージメント向上のキー ポイントとなるが、その中でも値が小さい尺度の方が改善の余地が大きい項目と いえる。よって、当社においてより効率的にエンゲージメントを向上させるためには、 上の図で右下に位置する「　　　」、「　　　」、「　　　」といった項目に取り組むことが有効であると考えられる。それらの尺度を構成する詳細の項目の結果の中でもより評価の低い（否定的な意見の多い）項目に着目し具体策を考える。";
          return dispatch(setReportDetail(res));
        })
        .catch(error => dispatch(openErrorDialog(error)));
    }
  },
  changeComment: (commentType, comment) => {
    dispatch(setNewComment(commentType, comment));
  },
  updateComment: (commentType, componentId, comment, attrItem = null) => {
    const elem = document.getElementById(componentId);
    const errorMessages = [];
    if (comment.length > 400) {
      errorMessages.push(`コメントは400字以内で入力してください。（現在${comment.length}文字）`);
    }
    if (elem.scrollHeight > elem.clientHeight) {
      errorMessages.push('コメントは入力エリアに収まるように（スクロールしないように）入力してください。');
    }
    if (errorMessages.length) {
      dispatch(
        openMessageDialog(
          errorMessages
        )
      );
      return;
    }
    const { id } = ownProps.match.params;
    const newComment = {
      commentType,
      comment,
      attrItem
    };
    api
      .post(`report_detail/${id}/update_comment`, newComment)
      .then(res => {
        if (res.errors.length > 0) {
          dispatch(showSnackbar(res.errors[0]));
        } else {
          dispatch(updateNewComment(res.commentType, res.comment));
          dispatch(showSnackbar("更新しました"));
        }
      })
      .catch(error => dispatch(openErrorDialog(error)));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(ReportDetail);



// WEBPACK FOOTER //
// ./src/containers/ReportDetail/ReportDetailContainer.js